import { ElementType, FC } from 'react';
import { alpha, SvgIconProps, Typography } from '@mui/material';
import {
    AudiotrackOutlined as AudiotrackOutlinedIcon,
    ImageNotSupported as ImageNotSupportedIcon,
    LiveTv as LiveTvIcon,
    OndemandVideo as OndemandVideoIcon,
    PhotoOutlined as PhotoOutlinedIcon,
    VideocamOutlined as VideocamOutlinedIcon,
} from '@mui/icons-material';
import Row from '../../components/Row';
import IconContainer from '../../components/Icon/IconContainer';

type MediaType = 'Audio' | 'Display' | 'Video' | 'Online Video' | 'Streaming TV';

const ICON_MAP: Record<MediaType, ElementType<SvgIconProps>> = {
    Audio: AudiotrackOutlinedIcon,
    Display: PhotoOutlinedIcon,
    Video: VideocamOutlinedIcon,
    'Online Video': OndemandVideoIcon,
    'Streaming TV': LiveTvIcon,
};

interface CampaignMediaTypeProps {
    value: MediaType | string;
}

const CampaignMediaType: FC<CampaignMediaTypeProps> = ({ value }) => {
    const Icon = (ICON_MAP as Record<string, ElementType<SvgIconProps>>)[value] ?? ImageNotSupportedIcon;

    return (
        <Row alignItems="center" height="100%" gap={1}>
            <IconContainer
                icon={Icon}
                size="medium"
                sx={{
                    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.25),
                    borderRadius: '50%',
                    borderWidth: 0,
                }}
            />

            <Typography variant="body2" color="text.secondary">
                {value}
            </Typography>
        </Row>
    );
};

export default CampaignMediaType;
